// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1vU8V","success":"styles_success__saYm8","error":"styles_error__3kOj6","loading":"styles_loading__20Rud"};